export default "__VITE_ASSET__D3Lo1864__"